import { call, put, takeLatest } from 'redux-saga/effects';
import { Posts } from 'services/api';
import {
  acceptPost,
  acceptPostSuccess,
  acceptPostFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* acceptPostSaga(action) {
  try {
    const data = yield call(Posts.acceptPost, action.payload);
    yield put(acceptPostSuccess(data));
    yield put(
      notificationActions.addNotification([
        { type: 'success', message: { code: 'moderatePosts.accept' } },
      ])
    );
  } catch (e) {
    yield put(acceptPostFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(acceptPost, acceptPostSaga);
